export default __webpack_public_path__ + "static/media/SanathanTextile_Dec21'3528.84b8e2c1.jpg";